import React from "react";

const SvgPlayerSetIn = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1rem"
    height="1rem"
    viewBox="0 0 16 16"
    fill="currentColor"
    style={{ display: "block" }}
  >
    <g transform="translate(3 1)">
      <path d="M4 12V2H8V0H2V6H0V8H2V14H8V12H4Z" fill="currentColor" />
    </g>
  </svg>
);
export default SvgPlayerSetIn;
